import { useCreateProgressionTemplateMutation } from "../../libs/progression/api";
import { ProgressionTemplate } from "../../libs/progression/types";
import { Modal } from "../Modal";
import { ProgressionForm } from "./ProgressionForm";

type Props = {
  openModal: string | undefined;
  setOpenModal: (modal: string | undefined) => void;
  defaultContainerId?: number | null;
};

export const CreateProgressionModal: React.FC<Props> = ({ openModal, setOpenModal, defaultContainerId }) => {
  const [createTemplate, { isLoading, error, data }] = useCreateProgressionTemplateMutation();

  const onSubmit = (template: Omit<ProgressionTemplate, "id">) => {
    createTemplate(template)
      .unwrap()
      .then(() => setOpenModal(undefined))
      .catch(() => {});
  };

  return (
    <Modal
      title="Nuova progressione"
      openModal={openModal === "create" ? "create" : undefined}
      setOpenModal={setOpenModal}
      fullScreen
    >
      {openModal === "create" && (
        <ProgressionForm
          onSubmit={onSubmit}
          isPending={isLoading}
          defaultContainerId={defaultContainerId ?? undefined}
        />
      )}
      {error && (
        <p className="mt-2 text-sm text-red-600">
          Errore durante la creazione della progressione.
        </p>
      )}
    </Modal>
  );
};
